import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import EditAcademicYear from "./routes/EditAcademicYear";
export default store => ({
  path: "academic-year-terms",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-schoolSetup" */ "./components"),
        import(
          /* webpackChunkName: "admin-schoolSetup" */ "./modules/AcademicYearTermsModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const module = importedModule1;
        const reducer = module.default;
        const key = module.NAME;
        injectReducer(store, {
          key,
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [EditAcademicYear(store)],
});
